<template>
  <div>
    <div class="sousuo" style="width: 100%">
      <div style="width: 450px" class="yl-flex flex_between">
        <Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
          <i-button slot="append" icon="ios-search"></i-button>
        </Input>
        <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
        <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
      </div>
    </div>

    <div class="multiple">
      <div class="child-div">时间区间</div>
      <RadioGroup v-model="timePeriod">
        <Radio label="0"><span>不限</span></Radio>
        <Radio label="1"><span>今日</span></Radio>
        <Radio label="2"><span>昨日</span></Radio>
        <Radio label="3"><span>本周</span></Radio>
        <Radio label="4"><span>上周</span></Radio>
        <Radio label="5"><span>本月</span></Radio>
        <Radio label="6"><span>上月</span></Radio>
        <Radio label="7"><span>自定义</span></Radio>
      </RadioGroup>
      <DatePicker
        v-if="timePeriod == 7"
        :value="timePeriodDate"
        @on-change="timePeriodDateChange"
        type="daterange"
        placeholder="选择日期"
        style="width: 200px; margin-left: 10px;"></DatePicker>
    </div>

    <div class="multiple" style="margin-bottom: 20px;">
      <div class="child-div">搜索条件</div>
      <Select v-model="cidType" style="width:150px;" clearable placeholder="类型">
        <Option v-for="item in cidTypeList" :value="item.id" :key="item.id">{{ item.type }}</Option>
      </Select>
      <Select v-model="city" style="width:150px;" clearable placeholder="城市">
        <Option v-for="item in cityList" :value="item.city" :key="item.city">{{ item.city }}</Option>
      </Select>
      <Select
        v-model="account"
        style="width: 150px;margin-left: 10px;"
        filterable multiple clearable
        placeholder="请选择账户">
        <Option v-for="item in accountList" :value="item.account_id" :key="item.account_id">
          {{ item.account_name}}
        </Option>
      </Select>
      <Select
        v-model="operationUser"
        style="width: 150px;margin-left: 10px;"
        filterable multiple clearable
        placeholder="请选择运营">
        <Option v-for="item in operationList" :value="item.uid" :key="item.uid">
          {{ item.username}}
        </Option>
      </Select>
    </div>

    <div id="myChart"></div>
    <div style="width: 100% ;margin-top: 20px;">
      <Table stripe border :columns="columns" :data="datas" ref="table">
        <!-- 账户类型 -->
        <template slot-scope="{ row }" slot="type">
          <span style="color:#63B3E6;cursor: pointer;"
            @click.stop="goAdvTypeStaticCity(row)">{{row.type}}</span>
        </template>
        <template slot-scope="{ row }" slot="zhuangku">
          <div>
            <span style="font-weight:bold">{{ row.zhuangku_num || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.zhuangku_num ? ((row.zhuangku_num || 0) / row.backNum * 100).toFixed(1) : 0 }}%</span>
          </div>
        </template>
        <!-- 0星：数量/比例（分母backNum） -->
        <template slot-scope="{ row }" slot="zero">
          <div>
            <span style="font-weight:bold">{{ row.zero || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.backNum ? ((row.zero || 0) / row.backNum * 100).toFixed(1) : 0 }}%</span>
          </div>
        </template>

        <!-- 1星：数量/比例（分母backNum） -->
        <template slot-scope="{ row }" slot="one">
          <div>
            <span style="font-weight:bold">{{ row.one || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.backNum ? ((row.one || 0) / row.backNum * 100).toFixed(1) : 0 }}%</span>
          </div>
        </template>

        <!-- 2星：数量/比例（分母backNum） -->
        <template slot-scope="{ row }" slot="two">
          <div>
            <span style="font-weight:bold">{{ row.two || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.backNum ? ((row.two || 0) / row.backNum * 100).toFixed(1) : 0 }}%</span>
          </div>
        </template>

        <!-- 3星：数量/比例（分母backNum） -->
        <template slot-scope="{ row }" slot="three">
          <div>
            <span style="font-weight:bold">{{ row.three || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.backNum ? ((row.three || 0) / row.backNum * 100).toFixed(1) : 0 }}%</span>
          </div>
        </template>

        <!-- 4星：数量/比例（分母backNum） -->
        <template slot-scope="{ row }" slot="four">
          <div>
            <span style="font-weight:bold">{{ row.four || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.backNum ? ((row.four || 0) / row.backNum * 100).toFixed(1) : 0 }}%</span>
          </div>
        </template>

        <!-- 2星+ 数量/优质率 -->
        <template slot-scope="{ row }" slot="twoPlus">
          <div>
            <span style="font-weight:bold">{{ row.twoPlusAdd || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.twoPlusRate || 0 }}</span>
          </div>
        </template>

        <!-- 3星+ 数量/优质率 -->
        <template slot-scope="{ row }" slot="threePlus">
          <div>
            <span style="font-weight:bold">{{ row.threePlus || 0 }}</span>
            <span style="margin:0 4px">/</span>
            <span style="color:#277dd3">{{ row.threePlusRate || 0 }}</span>
          </div>
        </template>

      </Table>
    </div>

    <Modal v-model="advGroupByCityModal" width="1200" title="">
      <AdvTypeGroupByCityStatic :timePeriod="timePeriod" :timePeriodDate="timePeriodDate">
      </AdvTypeGroupByCityStatic>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getAllMediumCode,
  getAllTypeStatic,
  getAdvTypeGroupByCityStaticList,
  getCidTypeList,
  getAdvCityList,
  getToutiaoSrc,
  getAllAccountList,
  getAllOperationList
} from "../../api/advManage";
import AdvTypeGroupByCityStatic from "./components/AdvTypeGroupByCityStatic.vue"

export default {
  name: "all_type_static",
  components: {
    AdvTypeGroupByCityStatic
  },
  props: ['AccountStatic'],
  data() {
    return {
      name: '',
      summary: '',
      timePeriod: '2',
      timePeriodDate: [],
      datas: [],
      advGroupByCityModal: false,
      cidType: [1],
      cidTypeList: [],
      cityList: [],
      accountList: [],
      operationList: [],
      operationUser: [],
      city: [],
      account: [],

      // 调整列宽适配比例展示
      columns: [
        { title: "账户类型", slot: "type", align: "center", width: 120 },
        { title: "城市", key: "city", align: "center", width: 100 },
        { title: "消耗", key: "cost", align: "center", width: 100 },
        { title: "平均成本", key: "average_cost", align: "center", width: 100 },
        { title: "广告转化", key: "account_convert", align: "center", width: 110 },
        { title: "系统转化", key: "srcNum", align: "center", width: 100 },
        { title: "已分发数量", key: "backNum", align: "center", width: 100 },
		{ title: "撞库数/比例", slot: "zhuangku", align: "center", width: 110 },
        { title: "0星", slot: "zero", align: "center", width: 110 },
        { title: "1星", slot: "one", align: "center", width: 110 },
        { title: "2星", slot: "two", align: "center", width: 110 },
        { title: "4星", slot: "four", align: "center", width: 110 },
        { title: "2星+", slot: "twoPlus", align: "center", width: 120 },
        { title: "3星+", slot: "threePlus", align: "center", width: 120 },
        { title: "2星+成本", key: "twoPlusCost", align: "center", width: 100 },
        { title: "3星+成本", key: "threePlusCost", align: "center", width: 100 },
      ],

      optionMy: {
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'top',
          backgroundColor: 'rgba(0,0,0,0)',
          borderWidth: 0,
          itemGap: 10,
          textStyle: { color: '#333' }
        },
        tooltip: {},
        xAxis: { data: [] },
        yAxis: [
          { type: 'value', name: '成本', position: "left", min: 0 },
          { type: 'value', name: '数量', position: "left", offset: 70, min: 0 },
          { type: 'value', name: '优质率(%)', min: 0, max: 100 }
        ],
        series: [
          {
            name: '转化', type: 'bar', yAxisIndex: 1, color: 'rgb(135 206 250)', data: [],
            label: { show: true, textStyle: { fontWeight: 'bolder', fontSize: 14 } }
          },
          {
            name: '平均成本', type: 'bar', data: [],
            label: { show: true, textStyle: { fontWeight: 'bolder', fontSize: 14 } }
          },
          {
            name: '优质成本', type: 'bar', data: [],
            label: { show: true, textStyle: { fontWeight: 'bolder', fontSize: 14 } }
          },
          {
            name: '优质率', type: 'line', yAxisIndex: 2, data: [],
            label: { show: true, textStyle: { fontWeight: 'bolder', fontSize: 14 } }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['token', 'userInfo'])
  },
  mounted() {
    this.loadData();
    this.getList();
    window.addEventListener('resize', () => {
      this.$echarts.init(document.getElementById("myChart")).resize();
    });
  },
  methods: {
    timePeriodDateChange(e) {
      this.timePeriodDate = e
    },
    initSearch() {
      this.name = '';
      this.summary = '';
      this.timePeriod = '2';
      this.timePeriodDate = [];
      this.cidType = [1];
      this.city = [];
      this.account = [];
      this.operationUser = [];
      this.getList();
    },
    async loadData() {
      const data = { token: this.token };
      try {
        const [
          cidRes, cityRes, srcRes, accountRes, operRes
        ] = await Promise.all([
          getCidTypeList(this, data),
          getAdvCityList(this, data),
          getToutiaoSrc(this, data),
          getAllAccountList(this, data),
          getAllOperationList(this, data)
        ]);
        this.cidTypeList = cidRes.data.list || [];
        this.cityList = cityRes.data.list || [];
        this.srcList = srcRes.data.list || [];
        this.accountList = accountRes.data.list || [];
        this.operationList = operRes.data.list || [];
      } catch (e) {
        console.error('加载基础数据失败：', e);
        this.$Message.error('数据加载失败，请重试');
      }
    },
    goAdvTypeStaticCity(row) {
      this.advGroupByCityModal = true;
    },
    async getList() {
      const data = {
        token: this.token,
        name: this.name,
        timePeriod: this.timePeriod,
        timePeriodDate: this.timePeriodDate,
        cidType: this.cidType,
        city: this.city,
        account: this.account,
        operationUser: this.operationUser
      };
      try {
        const res = await getAdvTypeGroupByCityStaticList(this, data);
        this.datas = res.data.list || [];

        const myChart = this.$echarts.init(document.getElementById("myChart"));
        const arr = this.datas;
        const x = [], num = [], cost = [], qualityCost = [], rate = [];
        for (let i = 1; i < arr.length; i++) {
          x.push(arr[i].city + arr[i].type);
          num.push(arr[i].srcNum || 0);
          cost.push(arr[i].average_cost || 0);
          qualityCost.push(arr[i].threePlusCost || 0);
          rate.push(arr[i].threePlusRate || 0);
        }
        this.optionMy.xAxis.data = x;
        this.optionMy.series[0].data = num;
        this.optionMy.series[1].data = cost;
        this.optionMy.series[2].data = qualityCost;
        this.optionMy.series[3].data = rate;
        myChart.setOption(this.optionMy);
      } catch (e) {
        console.error('获取统计数据失败：', e);
        this.$Message.error('数据查询失败，请重试');
      }
    },
    search() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="less">
#myChart {
  width: 100%;
  height: 600px;
  background-color: #fff;
  padding-top: 20px;
}

.multiple {
  display: flex;
  align-items: center;
  margin-top: 10px;

  .child-div {
    width: 70px;
    margin-right: 20px;
    text-align-last: justify;
  }
}

.sousuo {
  display: flex;
  width: 100%;
}

.yl-flex {
  display: flex;
}

.flex_between {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.ivu-table-cell {
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
}

:deep(.ivu-table th) {
  background: #277dd3;
  color: #fff;
  text-align: center !important;
}

// 比例文字样式优化
:deep(.ivu-table-cell) {
  font-size: 12px;
  span {
    display: inline-block;
    line-height: 1.2;
  }
}
</style>